import { render, staticRenderFns } from "./ApplicantDialog.vue?vue&type=template&id=20568b7c&scoped=true"
import script from "./ApplicantDialog.vue?vue&type=script&lang=js"
export * from "./ApplicantDialog.vue?vue&type=script&lang=js"
import style0 from "./ApplicantDialog.vue?vue&type=style&index=0&id=20568b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20568b7c",
  null
  
)

export default component.exports